import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from "react-helmet";

import ActiveForms from './admin/ActiveForms.js';
import NewForm from './admin/NewForm.js';
import ArchivedForms from './admin/ArchivedForms.js';
import { fetchForm } from '../actions';
import firebase from './Firebase.js';
import history from '../history';

class HomePage extends React.Component {
    componentDidMount() {

    }

    renderHelmet = () => {
        return (
            <Helmet defer={false}>
                {/*
                  Toggle the modern-page body styles via <html className>.
                  See client/src/index.css ".lg-modern-page" rules - they
                  override the legacy /css/loader.css (which forces
                  html/body to 100px), hide the full-screen .full-loader
                  overlay, and set the modern background + font. Using
                  <html> attributes (instead of an inline <style> tag)
                  ensures react-helmet@6.1 correctly REMOVES them on
                  unmount so they don't leak into /admin pages.
                */}
                <html className="lg-modern-page" />
                <meta charSet="utf-8" />
                <title>LoanGateway</title>
                <meta
                    name="description"
                    content="LoanGateway — Fact Find, Verification of Identity and Document Collection, made easy."
                />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale=1, shrink-to-fit=no"
                />
                <link rel="shortcut icon" href="assets/media/logos/favicon.ico" />
            </Helmet>
        );
    };

    render() {
        return (
            <div
                className="min-h-screen w-full flex flex-col"
                style={{ backgroundColor: '#F5F6FA' }}
            >
                {this.renderHelmet()}

                <header className="w-full">
                    <div className="mx-auto max-w-5xl px-5 sm:px-8 py-5 flex items-center justify-center sm:justify-start">
                        <img
                            src={process.env.PUBLIC_URL + '/images/logos/dark_transparent.png'}
                            alt="LoanGateway"
                            className="h-8 sm:h-9 w-auto"
                        />
                    </div>
                </header>

                <main className="flex-1 flex items-center">
                    <div className="mx-auto w-full max-w-3xl px-5 sm:px-8 py-12 sm:py-16">
                        <div className="rounded-3xl bg-white shadow-sm border border-[#E5E7EB] p-7 sm:p-10">
                            <span
                                className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold tracking-wide uppercase"
                                style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                            >
                                <span
                                    className="inline-block h-1.5 w-1.5 rounded-full"
                                    style={{ backgroundColor: '#7C5CFC' }}
                                />
                                LoanGateway
                            </span>
                            <h1 className="mt-4 text-3xl sm:text-4xl font-bold text-[#1F2937] leading-tight tracking-tight">
                                Fact Find, Verification of Identity &amp; Document Collection,{' '}
                                <span style={{ color: '#7C5CFC' }}>made easy.</span>
                            </h1>
                            <p className="mt-4 text-base sm:text-lg text-[#6B7280] leading-relaxed">
                                Made by brokers, for brokers. Securely share the details we
                                need to help with your enquiry. Your link, your data, your
                                control.
                            </p>

                            <div className="mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
                                <a
                                    href="/client"
                                    className="inline-flex items-center justify-center rounded-xl px-6 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95"
                                    style={{ backgroundColor: '#7C5CFC' }}
                                >
                                    Client login →
                                </a>
                            </div>

                            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-3 text-sm text-[#1F2937]">
                                <li className="flex items-start gap-3">
                                    <span
                                        className="inline-flex items-center justify-center h-6 w-6 rounded-full flex-shrink-0 mt-0.5"
                                        style={{ backgroundColor: '#DCFCE7', color: '#16A34A' }}
                                    >
                                        <svg
                                            className="h-3.5 w-3.5"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </span>
                                    Broker-grade encryption end-to-end.
                                </li>
                                <li className="flex items-start gap-3">
                                    <span
                                        className="inline-flex items-center justify-center h-6 w-6 rounded-full flex-shrink-0 mt-0.5"
                                        style={{ backgroundColor: '#DCFCE7', color: '#16A34A' }}
                                    >
                                        <svg
                                            className="h-3.5 w-3.5"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </span>
                                    Pick up where you left off, on any device.
                                </li>
                                <li className="flex items-start gap-3">
                                    <span
                                        className="inline-flex items-center justify-center h-6 w-6 rounded-full flex-shrink-0 mt-0.5"
                                        style={{ backgroundColor: '#DCFCE7', color: '#16A34A' }}
                                    >
                                        <svg
                                            className="h-3.5 w-3.5"
                                            viewBox="0 0 20 20"
                                            fill="currentColor"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </span>
                                    Your unique link, your data, never shared.
                                </li>
                            </ul>
                        </div>

                    </div>
                </main>

                <footer className="w-full py-6">
                    <div className="mx-auto max-w-5xl px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#6B7280]">
                        <span>
                            © {new Date().getFullYear()} LoanGateway. All rights reserved.
                        </span>
                        <div className="flex items-center gap-6">
                            <a href="/privacy" className="hover:text-[#1F2937] transition-colors">
                                Privacy
                            </a>
                            <a
                                href="tel:0292310511"
                                className="font-semibold"
                                style={{ color: '#5B3FE0' }}
                            >
                                02 9231 0511
                            </a>
                        </div>
                    </div>
                </footer>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return { id: state.id };
};

export default connect(mapStateToProps, { fetchForm })(HomePage);
